export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_MID = 'LOGIN_MID';
export const LOGOUT = 'LOGOUT';
export const TERMS = 'TERMS';
